import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import LoginView from 'src/views/auth/LoginView';
import NotFoundView from 'src/views/errors/NotFoundView';
import RegisterView from 'src/views/auth/RegisterView';

import Dashboard from 'src/views/dashboard';
import Logs from 'src/views/logs';
import KeyManager from 'src/views/keymanager';
import RouteManager from 'src/views/routes';
import StaffManager from 'src/views/profile';
import Topup from './views/topup';
import ClientManager from './views/clientmanager';
import APIAccessKey from './views/api-access-key';
import RequestHistory from './views/request-history';
import ReportsModule from './views/reports';
import RoutesCategory from './views/routes-category-manager';
import ClientStaffs from './views/clientmanager/Staffs/ClientStaffs';

// import index from './payments-page';

// const Dashboard = React.lazy(() => import('src/views/dashboard'));
// const Logs = React.lazy(() => import('src/views/logs'));
// const KeyManager = React.lazy(() => import('src/views/keymanager'));

const routes = [
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      { path: 'logs', element: <Logs /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'topup', element: <Topup /> },
      { path: 'key-manager', element: <KeyManager /> },
      { path: 'routes-manager', element: <RouteManager /> },
      { path: 'profile', element: <StaffManager /> },
      {
        path: 'client-manager',
        // element: <ClientManager />,
        children: [
          { path: '', element: <ClientManager /> },
          { path: 'staffs', element: <ClientStaffs /> }
        ]
      },
      { path: 'register', element: <RegisterView /> },
      { path: 'api-access-key', element: <APIAccessKey /> },
      { path: 'request-history', element: <RequestHistory /> },
      { path: 'reports', element: <ReportsModule /> },
      { path: 'route-categories', element: <RoutesCategory /> },
      { path: '', element: <StaffManager /> },
      { path: '/', element: <Navigate to="/dashboard" /> },
      { path: '*', element: <Navigate to="/dashboard" /> }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login', element: <LoginView /> },
      // { path: 'register', element: <RegisterView /> },
      { path: '404', element: <NotFoundView /> },
      { path: '/', element: <Navigate to="/login" /> },
      { path: '*', element: <Navigate to="/login" /> }
    ]
  }
];

export default routes;
